/**
  Pricing set API wrapper

**/

import { api } from "../common/utils"
import {
  PRICING_SET_ENDPOINT,
  PRICING_REORDER_ENDPOINT
} from "../common/constants"
import { FindPricingSetsResponse } from "../types"

export interface ReorderProfileWeight {
  wid: string
  ppid: string
}

export interface UpdateProfileOrderPayload {
  pricing_set_id: string
  new_weights: ReorderProfileWeight[]
}

const pricingSets = {
  find: async (params: any): Promise<FindPricingSetsResponse> => {
    const { data } = await api.get(PRICING_SET_ENDPOINT, { params })
    return data
  },
  updateProfileOrder: async (payload: UpdateProfileOrderPayload) => {
    const { data } = await api.post(PRICING_REORDER_ENDPOINT, payload)
    return data
  }
}

export default pricingSets
